export const imprintData = {
  title: 'Impressum',
  sections: [
    {
      title: 'Angaben gemäß § 5 TMG',
      content: [
        'Robin Wichmann',
        'Hauptstr. 58c',
        '21640 Bliedersdorf'
      ]
    },
    {
      title: 'Kontakt',
      content: [
        'E-Mail: kontakt@robinwichmann.com'
      ]
    },
    {
      title: 'Umsatzsteuer-ID',
      content: [
        'Umsatzsteuer-Identifikationsnummer gemäß § 27 a Umsatzsteuergesetz:',
        'DE304417567'
      ]
    },
    {
      title: 'Verantwortlich für den Inhalt nach § 55 Abs. 2 RStV',
      content: [
        'Robin Wichmann',
        'Hauptstr. 58c',
        '21640 Bliedersdorf'
      ],
      type: 'address'
    },
    {
      title: 'Haftungsausschluss',
      content: [
        'Die folgenden Hinweise geben einen Überblick über die rechtlichen Rahmenbedingungen dieser Website.'
      ],
      subsections: [
        {
          title: 'Haftung für Inhalte',
          content: [
            'Die Inhalte dieser Website wurden mit größter Sorgfalt erstellt.',
            'Für die Richtigkeit, Vollständigkeit und Aktualität der Inhalte können wir jedoch keine Gewähr übernehmen.',
            'Als Diensteanbieter sind wir gemäß § 7 Abs.1 TMG für eigene Inhalte auf diesen Seiten verantwortlich.',
            'Eine Kontrolle fremder Inhalte erfolgt nur bei konkretem Verdacht auf Rechtsverletzungen.'
          ]
        },
        {
          title: 'Haftung für Links',
          content: [
            'Unsere Website enthält Links zu externen Webseiten Dritter, auf deren Inhalte wir keinen Einfluss haben.',
            'Deshalb übernehmen wir keine Haftung für diese externen Inhalte.',
            'Zum Zeitpunkt der Verlinkung waren keine Rechtsverstöße erkennbar.',
            'Bei Bekanntwerden von Rechtsverletzungen werden wir die Links umgehend entfernen.'
          ]
        },
        {
          title: 'Urheberrecht',
          content: [
            'Die Inhalte dieser Website unterliegen dem deutschen Urheberrecht.',
            'Alle Rechte vorbehalten.',
            'Die Vervielfältigung, Bearbeitung oder Verwertung der Inhalte bedürfen der ausdrücklichen Zustimmung des jeweiligen Autors.',
            'Sollte ein Verstoß gegen das Urheberrecht vorliegen, bitten wir um einen entsprechenden Hinweis.'
          ]
        }
      ]
    }
  ]
}; 